export default {
  heading: "Заявки на публикацию",
  selectEvent: "Выберите выставку",
  selectEventPlaceholder: "Все выставки",
  searchPlaceholder: "Поиск компании",

  takeToWork: "Взять в работу",

  downloadDocx: "Сохранить файл в формате docx",
  downloadAllImages: "Сохранить изображения в общем архиве",
  downloadAll: "Скачать архив",

  reasonLabel: "Причина отклонения",
  linkLabel: "Ссылка на публикацию",

  publishRadioLabel: "Опубликовать",
  rejectRadioLabel: "Отклонить",

  tabFilter: {
    newTab: "Новые",
    workTab: "В работе",
    rejectedTab: "Отклоненные",
    postedTab: "Размещенные"
  }
};
